import { useState } from "react";
import Reveal from "@/components/base/Reveal";
import SectionHeading from "@/components/base/SectionHeading";
import { faqs } from "@/mocks/faqs";

export default function FaqSection() {
  const [openIndex, setOpenIndex] = useState(0);

  return (
    <section id="faq" className="bg-background-50 py-14 md:py-20">
      <div className="mx-auto w-full max-w-[1240px] px-4 md:px-6">
        <div className="grid grid-cols-1 gap-8 lg:grid-cols-12 lg:gap-12">
          <Reveal className="lg:col-span-4">
            <SectionHeading
              eyebrow="常见问题"
              title="关于这个专题，你可能想先弄清楚的事"
              desc="如果你对内容的整理方式、更新节奏或使用范围有疑问，先看这一部分通常就够了。"
            />
            <div className="mt-6 rounded-lg border border-background-200 bg-background-100 p-5">
              <p className="flex items-start gap-2 text-sm leading-relaxed text-foreground-600">
                <i className="ri-lightbulb-line mt-0.5 text-lg text-accent-600" />
                还有别的问题？直接给我们留言，涉及事实错误我们会在核实后更正。
              </p>
            </div>
          </Reveal>

          <Reveal className="lg:col-span-8" delay={80}>
            <div className="divide-y divide-background-200 border-t border-background-200">
              {faqs.map((faq, index) => {
                const isOpen = openIndex === index;
                return (
                  <div key={faq.question}>
                    <h3>
                      <button
                        type="button"
                        aria-expanded={isOpen}
                        onClick={() => setOpenIndex(isOpen ? -1 : index)}
                        className="flex w-full cursor-pointer items-start justify-between gap-4 py-5 text-left"
                      >
                        <span
                          className={`font-heading text-base font-semibold transition-colors md:text-[17px] ${
                            isOpen ? "text-primary-700" : "text-foreground-950"
                          }`}
                        >
                          {faq.question}
                        </span>
                        <span
                          className={`mt-0.5 flex h-6 w-6 shrink-0 items-center justify-center rounded-full transition-colors ${
                            isOpen ? "bg-primary-100 text-primary-700" : "bg-background-200 text-foreground-500"
                          }`}
                        >
                          <i className={isOpen ? "ri-subtract-line" : "ri-add-line"} />
                        </span>
                      </button>
                    </h3>
                    <div
                      className="overflow-hidden transition-all duration-300"
                      style={{ maxHeight: isOpen ? "320px" : "0px", opacity: isOpen ? 1 : 0 }}
                    >
                      <p className="pb-5 pr-10 text-sm leading-relaxed text-foreground-600">{faq.answer}</p>
                    </div>
                  </div>
                );
              })}
            </div>
          </Reveal>
        </div>
      </div>
    </section>
  );
}